/**
 *
 * Requres Slick Slider
 * https://kenwheeler.github.io/slick/
 *
 *
 */

jQuery(document).ready(function ($) {

  $('.tortuga-slider-block').slick({
    dots: false,
    arrows: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    centerMode: true,
    slidesToScroll: 1,
    centerPadding: '0px',
      // autoplay: true,
  });

})
